import { db } from "@/firebase";
// import moment from 'moment'

export default {
  state: {
    current: null,
    garage: null,
    flyTrap: null,
    waterTank: null,
    bufferTank: null,
    history: null,
    chartData: null,
  },

  mutations: {
    setCurrent(state, payload) {
      state.current = payload;
    },

    setFlyTrap(state, payload) {
      state.flyTrap = payload;
    },

    setWaterTank(state, payload) {
      state.waterTank = payload;
    },

    setBufferTank(state, payload) {
      state.bufferTank = payload;
    },

    setHistory(state, payload) {
      state.history = payload;
    },

    setGarage(state, payload) {
      state.garage = payload;
    },

    setChartData(state, payload) {
      state.chartData = payload;
    },
  },

  actions: {
    fetchCurrent({ commit }) {
      db.ref("Mill")
        .child("Current")
        .on("value", function(snapshot) {
          commit("setCurrent", snapshot.val());
        });
    },

    fetchFlytrap({ commit }) {
      db.ref("Mill")
        .child("FlyTrap")
        .on("value", function(snapshot) {
          commit("setFlyTrap", snapshot.val());
        });
    },

    fetchWaterTank({ commit }) {
      db.ref("Mill")
        .child("WaterTANK")
        .on("value", function(snapshot) {
          commit("setWaterTank", snapshot.val());
        });
    },

    fetchBufferTank({ commit }) {
      db.ref("Mill")
        .child("BufferTANK")
        .on("value", function(snapshot) {
          commit("setBufferTank", snapshot.val());
        });
    },

    fetchHistory({ commit }) {
      db.ref("Mill")
        .child("History")
        .on("value", function(snapshot) {
          commit("setHistory", snapshot.val());
        });
    },

    fetchGarage({ commit }) {
      db.ref("Mill")
        .child("Garage")
        .on("value", function(snapshot) {
          commit("setGarage", snapshot.val());
        });
    },

    fetchChartData({ commit }) {
      db.ref("Mill")
        .child("History")
        .orderByChild("Time")
        .on("value", function(snapshot) {
          const chartArray = new Array();

          snapshot.forEach((element) => {
            const chartData = {
              id: element.key,
              date: element.val().Time,
              tempIn: element.val().TempIn,
              tempOut: element.val().TempOut,
              humidity: element.val().Humidity,
              pressure: element.val().Pressure,
            };
            chartArray.push(chartData);
          });

          commit("setChartData", chartArray);
        });
    },
  },

  getters: {
    current(state) {
      return state.current;
    },
  },
};
